export default "__VITE_ASSET__BtXA8ybg__"